import { render, staticRenderFns } from "./RemoveThemesModal.vue?vue&type=template&id=f1b759fc"
import script from "./RemoveThemesModal.vue?vue&type=script&lang=js"
export * from "./RemoveThemesModal.vue?vue&type=script&lang=js"
import style0 from "./RemoveThemesModal.vue?vue&type=style&index=0&id=f1b759fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports